import { useEffect, useState } from "react";
import { apiDownloadFile } from "../../services/FilesService";

interface Props {
    fileName: any,
    width?: any,
    height?: any,
    /** Pokud je vyplněno, kliknutí otevře náhled v popupu místo nové záložky. */
    previewSize?: number
}

export const Picture = (props: Props) => {
    const [image, setImage] = useState<string>();
    const [imageLoading, setImageLoading] = useState(true);
    const [imageIsCorrupted, setImageIsCorrupted] = useState(true);
    const [previewVisible, setPreviewVisible] = useState(false);

    useEffect(() => {
        let isActive = true;

        setImageLoading(true);
        setImageIsCorrupted(false);

        apiDownloadFile(props.fileName)
            .then((response) => {
                if (!isActive) {
                    return;
                }

                let image = Buffer.from(response.data, 'binary').toString('base64');
                setImage(image);
                setImageLoading(false);
                setImageIsCorrupted(false);
            })
            .catch((ex: any) => {
                if (!isActive) {
                    return;
                }

                setImageLoading(false);
                setImageIsCorrupted(true);
            });

        return () => {
            isActive = false;
        };
    }, [props.fileName]);

    useEffect(() => {
        if (!previewVisible) {
            return;
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                setPreviewVisible(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [previewVisible]);

    const openImageAsNewTab = (imageData: any) => {
        var image = new Image();
        image.src = imageData;
        var w = window.open("");

        if (w) {
            w.document.write(image.outerHTML);
        }
    }

    const imageSource = `data:image/jpeg;charset=utf-8;base64,${image}`;
    const previewSize = props.previewSize;

    return (
        <>
            {imageLoading && <span style={{ display: 'inline-block', width: props.width || 50, height: props.height || 50 }} />}
            {!imageLoading && !imageIsCorrupted && <img style={{ cursor: 'pointer', width: props.width || 50, height: props.height || 50 }}
                loading="lazy"
                decoding="async"
                src={imageSource}
                onClick={() => {
                    if (previewSize) {
                        setPreviewVisible(true);
                    }
                    else {
                        openImageAsNewTab(imageSource);
                    }
                }}
            />}
            {imageIsCorrupted && <i className="fas fa-exclamation-triangle fa-2x"></i>}

            {previewVisible && previewSize && (
                <div
                    onClick={() => setPreviewVisible(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        zIndex: 100001,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                    }}
                >
                    <div
                        onClick={(event) => event.stopPropagation()}
                        style={{
                            backgroundColor: '#ffffff',
                            padding: '10px',
                            borderRadius: '4px',
                            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.4)',
                            cursor: 'default'
                        }}
                    >
                        <img
                            src={imageSource}
                            style={{ width: previewSize, height: previewSize, display: 'block' }}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
